import { render, staticRenderFns } from "./VideoSkeleton.vue?vue&type=template&id=a5f9bc7a"
import script from "./VideoSkeleton.vue?vue&type=script&lang=js"
export * from "./VideoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./VideoSkeleton.vue?vue&type=style&index=0&id=a5f9bc7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports